import { observable, action} from "mobx";
import {post} from "../services/ajax.service";

class ClinicalReviewStore {
    @observable reviewParticipants = 0;
    @observable reviewClaimsCount = 0;
    @observable reviewDrugsCount = 0;
    @observable totalReviewCost = 0;
    @observable reviewDrugsCost = [];
    @observable low_value_drug_participants = 0;
    @observable url ="/api/v1/insightactions/clinical_review";


    @action  getReviewParticipants = async(data) => {
      this.reviewParticipants = 0;
      try {
          let response = await post(
            `${this.url}/getReviewParticipants`,
            data
          );
    
          this.reviewParticipants =(new Set(response.data[0].unique_par.replace(/,\s*$/, "").split(",").filter(a => a != ""))).size;
        } catch (err) {
          console.log(err);
        }
  }
    @action  getReviewClaimsCount = async(data) => {
        this.reviewClaimsCount = 0;
        try {
            let response = await post(
              `${this.url}/getReviewClaimsCount`,
              data
            );
      
            this.reviewClaimsCount = response.data[0].COUNT;
          } catch (err) {
            console.log(err);
          }
    }
    @action  getReviewDrugsCount = async(data) => {
        this.reviewDrugsCount = 0;
        try {
            let response = await post(
              `${this.url}/getReviewDrugsCount`,
              data
            );
      
            this.reviewDrugsCount =(new Set(response.data[0].COUNT.replace(/,\s*$/, "").split(",").filter(a => a != ""))).size;
          } catch (err) {
            console.log(err);
          }
    }
    @action  getTotalReviewCost = async(data) => {
        this.totalReviewCost = 0;
        try {
            let response = await post(
              `${this.url}/getTotalReviewCost`,
              data
            );
      
            this.totalReviewCost = response.data[0].COST;
          } catch (err) {
            console.log(err);
          }
    }  
    @action  getReviewDrugsCost = async(data) => {
        this.reviewDrugsCost = [];
        try {
            let response = await post(
              `${this.url}/getReviewDrugsCost`,
              data
            );
      
            this.reviewDrugsCost = response.data;
          } catch (err) {
            console.log(err);
          }
    }  
    
  
}

export default ClinicalReviewStore;
